'use client';
import 'pixi.js/unsafe-eval';

import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
} from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from 'react-error-boundary';
import GlobalError from '@components/layout/global-error.jsx';
import Routes from './routes/routes.jsx';

const queryClient = new QueryClient();

const appRouter = createBrowserRouter(createRoutesFromElements(Routes()), {
  future: {
    v7_fetcherPersist: true,
    v7_relativeSplatPath: true,
    v7_startTransition: true,
    v7_partialHydration: true,
    v7_normalizeFormMethod: true,
    v7_skipActionErrorRevalidation: true,
  },
});

export function App() {
  return (
    <ErrorBoundary FallbackComponent={GlobalError}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={appRouter} />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
